export default __webpack_public_path__ + "static/media/ic_sentiment_very_dissatisfied_48px.a514f9c8.svg";